import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class StartingMetric extends Field {
  static attributesForModel() {
    return ['startingMetric'];
  }

  get title() {
    return 'Starting metric';
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-regular fa-gauge-simple-min' }, text: '25%' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.startingMetric) {
      return {
        icon: { name: 'fa-regular fa-gauge-simple-min' },
        text: record.startingMetric,
      };
    }

    return {};
  }
}
